"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = (0, _makeStyles.default)(function (theme) {
  return {
    rewardPoints: {
      "& .mco-form-input": {
        flex: "0 0 66%"
      }
    },
    button: {
      flex: "0 0 34%",
      marginLeft: theme.spacing(1)
    },
    isLoading: {
      "& svg": {
        height: 24,
        marginRight: theme.spacing(1),
        width: 24
      }
    },
    wrapper: {
      display: "flex"
    },
    redeemAmount: _defineProperty({
      display: "flex",
      flexWrap: "wrap",
      marginBottom: theme.spacing(2),
      "& .MuiAlert-message": {
        flex: 1
      },
      "& .MuiAlert-action": {
        marginLeft: 0,
        paddingLeft: 0,
        width: "100%"
      }
    }, theme.breakpoints.up("sm"), {
      "& .MuiAlert-message": {
        flex: "auto"
      },
      "& .MuiAlert-action": {
        marginLeft: "auto",
        paddingLeft: theme.spacing(2),
        width: "auto"
      }
    }),
    buttonDelete: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    buttonEdit: {
      marginRight: theme.spacing(1),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    buttonAll: {
      marginTop: theme.spacing(2)
    },
    text: {
      marginTop: theme.spacing(2)
    },
    information: {
      marginTop: theme.spacing(2)
    },
    message: {
      marginTop: theme.spacing(2)
    }
  };
});
var _default = styles;
exports.default = _default;